import styled from "styled-components";
import { device } from "../../../../utils/utils";
import lefHex from "../../assets/left-hex.png";
import rightHex from "../../assets/right-hex.png";

export const IntMypartnr = styled.div`
  position: relative;
  height: 220px;
  background: linear-gradient(180deg, #0B1B29 -79.84%, #554176 131.05%);
  display: flex;
  align-items: center;
  &::before{
    width: 195px;
    height: 220px;
    content: "";
    background: url(${lefHex}) 0 0 no-repeat;
    background-size: 100% 100%;
  }
  &::after{
    width: 195px;
    height: 220px;
    content: "";
    background: url(${rightHex}) 0 0 no-repeat;
    background-size: 100% 100%;
  }
  @media ${device.mobileS} {
    height: auto;
    padding: 40px 30px;
    position: relative;
    overflow: hidden;
    &::before{
      position: absolute;
      left: 0;
      top: 0;
      width: 160px;
      height: 160px;
    }
    &::after{
      width: 100px;
      height: 130px;
      position: absolute;
      right: 0;
      top: 0;
      transform: rotate(-85deg);
    }
  }
`;
export const IntMypartnrWrapper = styled.div`
  width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  padding: 0 40px;
  @media ${device.mobileS} {
    width: 100%;
   flex-direction: column;
   padding: 0;
   text-align: center;
  }
`;
export const IntMypartnrIcon = styled.span`
  width: 110px;
  flex-shrink: 0;
  margin-right: 30px;
  @media ${device.mobileS} {
    width: 87px;
    margin-right: 0;
  }
`;
export const IntMypartnrHdng = styled.h3`
  font-size: 32px;
  line-height: 38px;
  color: #fff;
  font-weight: 300;
  span{
    font-weight: 900;
  }
  @media ${device.mobileS} {
    font-size: 20px;
    line-height: 24px;
    margin-top: 30px;
    margin-bottom: 40px;
  }
`;
export const IntMypartnrCta = styled.a`
  width: 204px;
  height: 80px;
  display: inline-flex;
  border: 1px dashed #746C93;
  border-radius: 100px;
  align-items: center;
  justify-content: center;
  padding: 8px;
  position: relative;
  font-size: 16px;
  font-weight: 900;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer;
  flex-shrink: 0;
  margin-left: 100px;
  span{
    position: relative;
  }
  &::before{
    content: "";
    width: calc(100% - 16px);
    height: calc(100% - 16px);
    background: linear-gradient(111deg, #53B2FE 13.87%, #065AF3 121.84%);
    border-radius: 50px;
    position: absolute;
    left: 8px;
    top: 8px;
  }
  @media ${device.mobileS} {
    width: 180px;
    height: 72px;
    margin-left: unset;
  }
`;